module.exports = __webpack_public_path__ + "static/img/恭喜300.765bdaa8.png";